import { useEffect } from "react";
import "@/App.css";
import { Nav } from "@/components/yeti/Nav";
import { Hero } from "@/components/yeti/Hero";
import { Features } from "@/components/yeti/Features";
import { Pro } from "@/components/yeti/Pro";
import { Sections } from "@/components/yeti/Sections";
import { Faq } from "@/components/yeti/Faq";
import { Footer } from "@/components/yeti/Footer";
import { FoodReviewAdmin } from "@/components/admin/FoodReviewAdmin";

export default function App() {
  const isAdminRoute = window.location.pathname === "/admin" || window.location.pathname.startsWith("/admin/");
  useEffect(() => {
    const els = document.querySelectorAll(".reveal");
    const reduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (reduced || !("IntersectionObserver" in window)) {
      els.forEach((el) => el.classList.add("is-visible"));
      return;
    }
    const io = new IntersectionObserver(
      (entries) =>
        entries.forEach((e) => {
          if (e.isIntersecting) {
            e.target.classList.add("is-visible");
            io.unobserve(e.target);
          }
        }),
      { threshold: 0.12, rootMargin: "0px 0px -40px 0px" }
    );
    els.forEach((el) => io.observe(el));
    return () => io.disconnect();
  }, []);

  if (isAdminRoute) return <FoodReviewAdmin />;

  return (
    <div className="aktua-site">
      <a href="#main" data-testid="skip-link" className="skip-link">
        Skip to content
      </a>
      <Nav />
      <main id="main">
        <Hero />
        <Features />
        <Pro />
        <Sections />
        <Faq />
      </main>
      <Footer />
    </div>
  );
}
